import { defineSlotRecipe } from '@chakra-ui/react';
import { menuAnatomy } from '@chakra-ui/react/anatomy';

export const menuSlotRecipe = defineSlotRecipe({
  className: 'ac-menu',
  slots: menuAnatomy.keys(),
  base: {
    trigger: {
      _active: {
        borderColor: 'grey.dark.2',
      },
      _open: {
        borderColor: 'grey.dark.2',
      },
    },
    content: {
      outline: 'none',
      backgroundColor: 'bg',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'grey.dark.2',
      borderRadius: 'smaller',
      padding: '5px 5px',
      maxHeight: 'var(--available-height)',
      zIndex: 200,
      _open: {
        animationStyle: 'menu-open',
        animationDuration: 'moderate',
      },
      _closed: {
        animationStyle: 'menu-close',
        animationDuration: 'moderate',
      },

      '& > :not(:first-child) ': {
        marginTop: '5px',
      },
    },
    itemGroup: {
      _notFirst: {
        borderTop: '1px solid {colors.grey.light.1}',
      },
    },
    item: {
      height: '40px',
      minW: '180px',
      padding: '0px 20px',
      backgroundColor: 'grey.light.0',
      userSelect: 'none',
      display: 'flex',
      flexDir: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',

      position: 'relative',

      transitionProperty: 'border, backgroundColor, background, color',
      transitionDuration: 'slow',
      transitionBehavior: 'linear',

      _disabled: {
        color: 'grey.light.2',
      },

      '& > svg': {
        width: '16px',
        height: '16px',

        marginRight: '-8px',
      },

      '&[data-type]': {
        paddingLeft: '32px',
      },

      _hover: {
        backgroundColor: 'halton.green/10',
        // backgroundColor: 'grey.light.1',
      },

      _first: {
        borderTopRadius: 'small',
      },
      _last: {
        borderBottomRadius: 'small',
      },
    },

    itemIndicator: {
      width: '16px',
      height: '16px',
      position: 'absolute',
      transform: 'translateY(-50%)',
      top: '50%',
      left: '10px',
      '& > svg': {
        width: '100%',
        height: '100%',
      },
    },
  },
  variants: {
    narrow: {
      true: {
        item: {
          minW: '50px',
        },
      },
    },
    submenu: {
      true: {
        content: {
          marginLeft: '4px',
          marginRight: '4px',
        },
      },
    },
    variant: {
      plain: {
        content: {
          '& > :not(:first-child) ': {
            marginTop: '15px',
          },
        },
        item: {
          backgroundColor: 'white',
          minHeight: '28px',
          height: 'auto',

          '&:not(:first-child)': {
            marginTop: '15px',
          },

          _hover: {
            backgroundColor: 'white',
          },
        },
        itemGroupLabel: {
          padding: '0px 20px',
          fontSize: '14px',
          fontWeight: 400,
          letterSpacing: '0.14px',
          color: 'grey.dark.2',
        },
        itemGroup: {
          _notFirst: {
            // borderTop: '1px solid {colors.grey.light.1}',
            borderTop: 'none',
          },
          _first: {
            paddingTop: '5px',
          },
          _last: {
            paddingBottom: '5px',
          },
        },
      },
      context: {
        content: {
          padding: '0px',
          overflow: 'hidden',
        },
        itemGroupLabel: {
          fontWeight: 600,
          // height: '40px',
          padding: '10px',
          textTransform: 'capitalize',
        },
        item: {
          minW: '150px',
          backgroundColor: 'grey.light.0',

          _even: {
            backgroundColor: 'white',
          },

          _hover: {
            backgroundColor: 'halton.green/10',
          },

          marginTop: '0px !important',
        },
      },
      compact: {
        content: {
          padding: '0px',
          overflow: 'hidden',
        },
        itemGroupLabel: {
          fontWeight: 600,
          // height: '40px',
          padding: '8px 10px',
          textTransform: 'capitalize',
          fontSize: '14px',
        },
        itemGroup: {
          _last: {
            overflow: 'hidden',
            borderBottomLeftRadius: 'smaller',
            borderBottomRightRadius: 'smaller',
          },
        },
        item: {
          display: 'flex',
          justifyContent: 'space-between',
          gap: '20px',

          height: '32px',
          padding: '0px 12px',
          minW: '150px',
          fontSize: '14px',

          backgroundColor: 'grey.light.0',

          _even: {
            backgroundColor: 'white',
          },

          '& > svg': {
            marginRight: '0px',
          },
        },
      },
    },
  },
});
